import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi } from '@mint-sdk/api-core';

import {
  AdFormOptionsResponseSchema,
  AdFormResponseSchema,
} from '../shared/schemas/AdFormSchema.js';

export const getAdFormIntegrations = defaultApi.declareEndpoint({
  url: 'adform/v2/integrations/' as const,
  method: 'GET',
  responseSchema: AdFormResponseSchema,
});

export const getAdFormOptions = defaultApi.declareEndpoint({
  url: 'adform/authorization_options/' as const,
  method: 'GET',
  responseSchema: AdFormOptionsResponseSchema,
});

export const getQueryOptions = makeQueryOptions(getAdFormIntegrations, {
  processResponse(data) {
    return data;
  },
});

export const getAdFormOptionsQueryOptions = makeQueryOptions(getAdFormOptions, {
  processResponse(data) {
    return data;
  },
});
